import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 删除邮件模板
const sendNormalMail = obj => new Promise((resolve, reject) => {
    const {
        sendForm,
        token
    } = obj;
    request({
        url: apis.mail_normal_send + '?token='  + token,
        data:sendForm
    }).then(res => {
        resolve(res);
    })
});

// 修改邮件模板
const sendSystemMail = obj => new Promise((resolve, reject) => {
    const {
        sendForm,
        token
    } = obj;
    request({
        url: apis.mails_system_send + '?token='  + token,
        data: sendForm
    }).then(res => {
        resolve(res);
    })
});

//普通邮件-查询全部
const findAllNormalMails = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj;
    request({
        url: apis.mail_normal_find_all + '?token=' + token
    }).then(res => {
        resolve(res);
    })
});

//普通邮件-批量邮件查询
const findAllBatchMails = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj;
    request({
        url: apis.mail_batch_find_all + '?token=' + token
    }).then(res => {
        resolve(res);
    })
});

const findAllSystemMails = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj;
    request({
        url: apis.mails_system_find_all + '?token=' + token
    }).then(res => {
        resolve(res);
    })
});

const modifySystemMail = obj => new Promise((resolve, reject) => {
    const {
        token,
        modifyForm
    } = obj;
    request({
        url: apis.mails_system_modify + '?token=' + token,
        data :modifyForm,
    }).then(res => {
        resolve(res);
    })
});

export default {
    sendNormalMail,
    sendSystemMail,
    findAllSystemMails,
    modifySystemMail,
    findAllNormalMails,
    findAllBatchMails
}



// WEBPACK FOOTER //
// ./src/service/mail_api.js